<template>    
 
      <v-navigation-drawer
        v-model="drawer"
        :color="color"
        :expand-on-hover="expandOnHover"
        :mini-variant="miniVariant"
        :right="right"
        :permanent="permanent"
        :src="bg"
        absolute
        dark
        v-if="isloggedin"
      >
        <v-list
          dense
          nav
          class="py-0"
        >
          <center class="mt-5 mb-3">
          <v-avatar size="70">
            <img src="https://clarionit.in/assets/images/smallogo-78x78.png">
          </v-avatar>
          </center>
          <h4 align="center" class="mb-3 text-capitalize">{{ currentuser.name }}</h4>

          <v-divider></v-divider>

          <v-list-item
            
            link
            to="/home"
          >
          
            <v-list-item-icon>
              <v-icon>mdi-view-dashboard</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Project</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
             v-for="item in subset"
            :key="item"
          >
            <v-list-item-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            
            link
            to="/mytask"
          >
          
            <v-list-item-icon>
              <v-icon>mdi-image</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>My Task</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
         <v-list-item
            
            link
            to="/subscriptions"
          >
          
            <v-list-item-icon>
              <v-icon>mdi-image</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Subscription</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            
            link
            to="/clients"
          >
          
            <v-list-item-icon>
              <v-icon>mdi-image</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Client</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          
          <v-list-item
            link
            @click.prevent="logout"
          >
          
            <v-list-item-icon>
              <v-icon>mdi-image</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </v-list>
            <v-snackbar
            :top="true"
            :right="true"
            v-model="snackbar.snackbar"
            :timeout="snackbar.timeout"
            :color="snackbar.color"
            >
            {{ snackbar.text }}

            <template v-slot:action="{ attrs }">
                <v-btn
                color="red"
                text
                v-bind="attrs"
                @click="snackbar.snackbar = false"
                >
                Close
                </v-btn>
            </template>
            </v-snackbar>
      </v-navigation-drawer>
</template>

<script>
import Api from '../apis/Api.js';
import { mapGetters,mapActions } from 'vuex';
  export default {
    data () {
      return {
        drawer: true,
        items: [
          { title: 'Project', icon: 'mdi-view-dashboard', to: '/' },
          { title: 'Subscription', icon: 'mdi-image', to: '/subscription' },
        ],
        subset: ['Website','Application','Branding','Others'],
        color: 'primary',
        colors: [
          'primary',
          'blue',
          'success',
          'red',
          'teal',
        ],
        right: false,
        permanent: true,
        miniVariant: false,
        expandOnHover: false,
        background: false,
        isloggedin: false,
        snackbar: {
            snackbar: false,
            text: '',
            color: '',
            timeout: 3000,
        }
      }
    },
    computed: {
      ...mapGetters(["currentuser"]),
      bg () {
        return this.background ? 'https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg' : undefined
      },
    },
    mounted() {
      this.isloggedin = !!localStorage.getItem('token');
      if(this.isloggedin)
      {
        Promise.all([this.fetchprojects(),
        this.fetchclients(),
        this.fetchtasks(),
        this.fetchcontacts(),
        this.fetchusers(),
        this.fetchuser(),
        this.fetchsalespersons()])
        .then(() => {
          this.$store.dispatch('showsnackbar',{ message: "All Data Retrieved Successfully..", color: "success" });
        })
        .catch((error) => {
          this.$store.dispatch('showsnackbar',{ message: error, color: "error" });
        });
      }
    },
    methods: {
      ...mapActions(['fetchclients','fetchprojects','fetchcontacts','fetchsalespersons','fetchusers','fetchuser','fetchtasks','showsnackbar']),
      logout(){
        Api().post('/logout').then(() => {
          localStorage.removeItem("token");
          this.$router.push('/');
        });
      }
    }
  }
</script>